package utils

import com.myrestaurants.sharedmodels.PlaceInfo2
import com.myrestaurants.sharedmodels.PlaceInfoShared
import kotlin.math.PI
import kotlin.math.atan2
import kotlin.math.cos
import kotlin.math.sin
import kotlin.math.sqrt

fun validEmail(email: String): Boolean {
    val emailRegex = Regex(
        "[a-zA-Z0-9+._%\\-]{1,256}" +
                "@" +
                "[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}" +
                "(" +
                "\\." +
                "[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25}" +
                ")+"
    )
    return email.matches(emailRegex)
}

fun getPlaceInfo2FromPlaceInfo(pi: PlaceInfoShared): PlaceInfo2 {
    val pi2 = PlaceInfo2()
    pi2.placeId = pi.placeId
    pi2.name = pi.name
    pi2.rating = pi.rating
    pi2.priceRange = pi.priceRange
    pi2.isWish = pi.isWish
    pi2.latlng = pi.latlng
    return pi2
}

fun getDistanceFromLatLonInKm(
    lat1: Double,
    lon1: Double,
    lat2: Double,
    lon2: Double
): Double {
    val R = 6371.0 // Radius of the earth in km
    val dLat = deg2rad(lat2 - lat1) // deg2rad below
    val dLon = deg2rad(lon2 - lon1)
    val a =
        sin(dLat / 2) * sin(dLat / 2) + cos(
            deg2rad(
                lat1
            )
        ) * cos(deg2rad(lat2)) * sin(dLon / 2) * sin(
            dLon / 2
        )

    val c = 2 * atan2(sqrt(a), sqrt(1 - a))
    val d = R * c // Distance in km
    return d
}

fun deg2rad(deg: Double): Double {
    return deg * (PI / 180)
}